export default __webpack_public_path__ + "static/media/ponderosa_cedar.636322f4.png";